import { useDispatch } from 'react-redux';

import { closeModal, openModal } from '@app/redux/modal';

import type { ReturnRequestModalProps } from '../components/ReturnRequestModal';
import { ReturnRequestModal } from '../components/ReturnRequestModal';

function useReturnRequestModal() {
  const dispatch = useDispatch();

  const closeReturnModal = () => {
    dispatch(closeModal());
  };

  const openReturnModal = ({
    orderDate,
    orderProducts,
    orderUid,
    contactEmail,
    onSuccess,
    onError,
  }: ReturnRequestModalProps) => {
    dispatch(
      openModal({
        label: 'return-request',
        additionalClass: 'return-request',
        content: (
          <ReturnRequestModal
            orderDate={orderDate}
            orderUid={orderUid}
            orderProducts={orderProducts}
            contactEmail={contactEmail}
            onSuccess={onSuccess}
            onError={onError}
          />
        ),
      }),
    );
  };

  return { openReturnModal, closeReturnModal };
}

export { useReturnRequestModal };
